import React from 'react';
import { Button, Col } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { TERMS_CONDITIONS_LINK } from '../../../../utils/constants';

export const FlagContentMessage = ({
  closeModal,
  reportProfile
}) => {
  return (
    <>
      <h2>Report Candidate Profile</h2>
      <p>
        Please refer to our{' '}
        <a
          className="link-blue"
          target="_blank"
          rel="noopener noreferrer"
          href={TERMS_CONDITIONS_LINK}
        >
          Terms and Conditions
        </a>{' '}
        before reporting this candidate profile. <br /><br />
        The Home Depot Path to Pro team will review the profile.
        If we determine the individual is in violation of our{' '}
        <a
          className="link-blue"
          target="_blank"
          rel="noopener noreferrer"
          href={TERMS_CONDITIONS_LINK}
        >
          Terms and Conditions
        </a>, we will
        take appropriate action.
      </p>
      <div className="flag-content__buttons">
        <Col className="flag-content__button-with-border">
          <Button
            data-testid="close-report-profile-modal"
            outline
            aria-label="Cancel report profile button"
            onClick={closeModal}
          >
          Cancel
          </Button>
        </Col>
        <Col className="flag-content__button-with-border">
          <Button
            data-testid="report-profile-close-modal"
            aria-label="Report profile button"
            onClick={reportProfile}
            transparent
          >
          Report Profile
          </Button>
        </Col>
      </div>
    </>
  );
};

FlagContentMessage.propTypes = {
  closeModal: PropTypes.func.isRequired,
  reportProfile: PropTypes.func.isRequired
};
